import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import type { CustomAttributes } from "app/services/track/track";

const createPremiumFeatureTrackingService = (track: TrackFn) => {
    const trackPremiumFeatureAction = (eventName: string, customEvent?: CustomAttributes) => {
        track("sales intelligence hooks", "click", eventName, customEvent);
    };

    const trackPremiumFeatureClickFilter = (eventName: string, customEvent?: CustomAttributes) => {
        track("Filter", "click", eventName, customEvent);
    };

    return {
        trackPremiumFeatureAction,
        trackPremiumFeatureClickFilter,
    };
};

export default createPremiumFeatureTrackingService;
